export default __webpack_public_path__ + "static/media/money1.ccff3ab6.jpg";